// Upravljanje pristankom na kolačiće (Consent Mode v2 + PostHog).
//
// Kategorije:
//  - necessary : uvijek aktivni (rad sajta, korpa). Ne traže pristanak.
//  - analytics : PostHog + Google analytics_storage.
//  - marketing : Google Ads (ad_storage, ad_user_data, ad_personalization).

export const CONSENT_STORAGE_KEY = "cookie_consent_v1";

// Event koji banner emituje da bi se UI (npr. footer link) mogao osvježiti.
export const CONSENT_CHANGED_EVENT = "cookie-consent-changed";

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasDecided() {
  return getStoredConsent() !== null;
}

// Primijeni izbor: upiši u localStorage i obavijesti Google + PostHog.
export function applyConsent({ analytics, marketing }) {
  const value = {
    necessary: true,
    analytics: !!analytics,
    marketing: !!marketing,
    updatedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(value));
  } catch {
    // localStorage nedostupan (npr. privatni mod) — nastavi bez perzistencije.
  }

  // Google Consent Mode v2
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: marketing ? "granted" : "denied",
      ad_user_data: marketing ? "granted" : "denied",
      ad_personalization: marketing ? "granted" : "denied",
      analytics_storage: analytics ? "granted" : "denied",
    });
  }

  // PostHog
  if (typeof window !== "undefined" && window.posthog) {
    if (analytics) {
      window.posthog.opt_in_capturing();
    } else {
      window.posthog.opt_out_capturing();
    }
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: value }));
  }

  return value;
}

export function acceptAll() {
  return applyConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
  return applyConsent({ analytics: false, marketing: false });
}
